import { Component, Prop, Vue, Watch, } from 'vue-property-decorator';

import * as ol from 'ol/'

import WithRender from './ClosableWindow.html';
import './ClosableWindow.scss'
import SmartButton from 'tivigi/src/components/SmartButton/SmartButton';


@WithRender
@Component({
    components: {
        SmartButton
    },
})
export default class ClosableWindow extends Vue {

    //################# BEGIN Props #################
    @Prop()
    show!: boolean;

    //################# END Props #################



    onCloseButtonClick(){

        this.$emit('update:show', false)
    }
    
}


